<template>
  <div class="header-container">
    <div class="header-main">
      <div class="brand">
        <div class="brand-logo">
          <a href="/">
            <img src="../../../assets/images/home/logo.png" alt="">
          </a>
        </div>
      </div>
      <div class="header-nav">
        <div class="main-menu">
          <el-menu 
            :default-active="activeIndex"
            mode="horizontal"
            text-color="#161616"
            active-text-color="#409eff"
            router
            class="nav"
            >
            <el-menu-item index="/resize-images">尺寸修改</el-menu-item>
            <el-menu-item index="/compress-images">图片压缩</el-menu-item>
            <el-menu-item index="/format-images">格式转换</el-menu-item>
            <el-menu-item index="/watermark-images">添加水印</el-menu-item>
            <el-menu-item index="/puzzle-images">拼图</el-menu-item>
            <el-submenu index="2">
              <template slot="title">更多工具</template>
              <el-menu-item index="/crop-images">图片裁剪</el-menu-item>
              <el-menu-item index="/text">添加文字</el-menu-item>
              <el-menu-item index="/rotate-images">图片旋转</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="top-menu">
        <!-- <ul class="nav">
          <li class="nav_item nav_item--gray">
            <a href="/login">
            登陆</a>
          </li>
          <li class="nav_item nav_item--blue">
            <a href="/register">注册</a>
          </li>
        </ul> -->
        <ul class="download-nav">
          <li class="transfer_item" @click="queryStatus(); isActive = true;" ref="transfer_item">
            <img class="download-img" src="../../../assets/images/page/transfer-green.png" alt="">
            <div class="mask" ref="mask">
              <button class="btn" @click=queryStatus()>刷新</button>
              <p class="txt"><span>二维码已失效</span><br><span>请刷新重试</span></p>
            </div>
            <div class="download-qrcode-wrap" ref="qrcode" :class="{ 'show-qrcode-wrap': isActive }">
              <img class="qrcode" :src=captchaURL>
              <p style="font-size:14px;margin-top: -16px">请使用倍明开发者应用扫描二维码</p>
            </div>
          </li>
          <li class="nav_item" @click="isDownload = true;" ref="qrcode_wrap">
            <img class="download-img" src="../../../assets/images/page/dowload.png" alt="">
            <div class="qrcode-wrap" :class="{'download-qrcode-wrap ': isDownload}" >
              <img class="qrcode" src="../../../assets/images/page/share.png">
              <p style="font-size:14px">扫码下载图片编辑助手APP</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="dialog">
      <el-dialog title="" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" :append-to-body=true>
        <span>倍明图片编辑 图片传输完成</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="getDownload(); closeMask()">保存至电脑</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      activeIndex: '',
      captchaURL: '',
      token: '',
      download: 0,
      dialogVisible: false,
      isActive: false,
      timer: null,
      isDownload: false
    }
  },
  mounted() {
    this.setActiveIndex();
    this.getInitData();
    document.addEventListener('mouseup', () => {
      let trans = this.$refs.transfer_item;
      if (trans) {
        this.closeMask();
      }
    });
    document.addEventListener('mouseup', () => {
      let qrcode = this.$refs.qrcode_wrap;
      if (qrcode) {
        this.isDownload = false;
      }
    })
  },
  watch: {
    // 监听路由变化
    $route: function () {
      this.setActiveIndex();
    }
  },
  methods: {
    setActiveIndex() {
      if (this.$route.meta && this.$route.meta.name) {
        this.activeIndex = this.$route.meta.name;
      } else {
        this.activeIndex = this.$route.path;
      }
    },
    getInitData() {
      this.$axios({
        url: 'https://cosmos.bayescom.com/cosmos/qr_code',
        method: 'get',
        responseType: 'arraybuffer'
      }).then(req => {
        this.token = req.headers.get("Token")
        this.captchaURL = "data:image/png;base64," + btoa(new Uint8Array(req.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
      }).catch(err => {
        console.log(err);
      })
    },
    showMask() {
      this.$refs.mask.style.display = 'block'
    },
    closeMask() {
      this.$refs.mask.style.display = 'none'
      this.isActive = false;
    },
    getDownloadStatus() {
      this.$axios({
        method: 'get',
        url: 'https://cosmos.bayescom.com/cosmos/download_check',
        params: { 'token': this.token }
      }).then(req => {
        if (req.data.status === 0) {
          this.$refs.mask.style.display = 'none';
          this.download = req.data.result.download;
        }
      }).catch(err => {
        console.log(err);
      })
    },
    queryStatus() {
      this.getInitData()
      this.download = 0;
      if (!this.timer) {
        this.timer = window.setInterval(() => {
          if (this.download === 0) {
            this.getDownloadStatus();
          } else if (this.download === 1) {
            clearInterval(this.timer)
            this.timer = null;
            this.dialogVisible = true;
          } else {
            clearInterval(this.timer)
            this.timer = null;
            if(this.isActive === true){
              this.showMask()
            }
          }
        }, 1000)
      }
    },
    getDownload() {
      window.open('https://cosmos.bayescom.com/cosmos/download?token=' + this.token)
      if (this.isActive === true) {
            this.showMask();
      }
      this.dialogVisible = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  background: #fff;
  width: 100%;
  height: 60px;
  z-index: 1041;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  min-width: 1200px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;


  .header-main {
    background: #fff;
    padding: 0;
    height: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: justify;
    justify-content: space-between;
    border-bottom: 1px solid #e6e6e6;

    .brand {
      line-height: 20px;
      height: 60px;
      margin: 0px 20px;
      display: flex;
      align-items: center;

      .brand-logo {
        width: 120px;
        max-height: 100%;

        img {
          width: 100%;
          max-width: 100%;
          height: auto;
        }
      }
    }

    .header-nav {
      padding: 0;
      margin: 0 auto;
      flex: 1 1;
      height: 60px;

      .main-menu {
        background-color: #fff;
        border-top: 0;
        margin: 0;
        margin-left: 80px;
        font-size: 14px;
        height: 60px;
        font-weight: 600;

        /deep/ .el-menu.el-menu--horizontal {
          box-sizing: border-box;
          height: 60px;
        }
        /deep/ .el-menu-item {
          padding: 0 15px;
        }
      }
    }

    .top-menu {
      float: right;
      position: relative;

      .download-nav {
        margin-right: 50px;
        height: 60px;
        width: 100px;
        display: flex;

        .nav_item {
          position: relative;
          width: 50%;
          height: 100%;
          padding: 20px;

          .download-img {
            width: 20px;
            height: 20px;
          }

          .qrcode-wrap {
            position: absolute;
            font-size: 16px;
            background-color: #fff;
            z-index: 99;
            top: 60px;
            right: -20px;
            padding: 20px;
            transform: scale(0);
            transform-origin: top right;
            opacity: 0;
            -webkit-transition: all .4s ease-in-out;
            -o-transition: all .4s ease-in-out;
            transition: all .4s ease-in-out;
            box-shadow: 0 2px 12px 0px rgba(0, 0, 0, 0.1);
            border-radius: 4px;

            .qrcode {
              width: 100px;
              height: 100px;
            }
          }

          &:hover {
            cursor: pointer; 
          }
          .download-qrcode-wrap {
              transform: scale(1);
              opacity: 1;
            }
        }

        .transfer_item {
          position: relative;
          width: 50%;
          height: 100%;
          padding: 20px;

          .download-img {
            width: 20px;
            height: 20px;
          }

          .mask {
            width: 180px;
            height: 185px;
            position: absolute;
            top: 60px;
            right: -20px;
            z-index: 100;
            padding-top: 50px;
            background-color: rgba(255, 255, 255, 0.9);
            color: rgb(77, 77, 77);
            font-size: 11px;
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
            display: none;

            .btn {
              width: 84px;
              height: 29px;
              line-height: 20px;
              border-radius: 3px;
              background-color: rgba(77, 171, 97, 1);
              color: rgba(255, 255, 255, 1);
              font-weight: bold;
              font-size: 14px;
              text-align: center;
            }

            .btn:hover {
              cursor: pointer;
            }

            .txt {
              margin-top: 10px;
            }
          }

          .download-qrcode-wrap {
            width: 180px;
            position: absolute;
            font-size: 16px;
            background-color: #fff;
            z-index: 99;
            top: 60px;
            right: -20px;
            padding-bottom: 6px;
            transform: scale(0);
            transform-origin: top right;
            opacity: 0;
            -webkit-transition: all .4s ease-in-out;
            -o-transition: all .4s ease-in-out;
            transition: all .4s ease-in-out;
            box-shadow: 0 2px 12px 0px rgba(0, 0, 0, 0.1);
            border-radius: 4px;

            .qrcode {
              width: 150px;
              height: 150px;
            }
          }

          &:hover {
            cursor: pointer;
          }

          .show-qrcode-wrap {
            transform: scale(1);
            opacity: 1;
          }
        }
      }

      .nav {
        padding: 0;
        margin: 0;
        display: flex;

        .nav_item {
          margin: 0;
          height: 100%;

          a {
            display: flex;
            -ms-flex-align: center;
            align-items: center;
            font-size: 14px;
            font-weight: 600;
            line-height: 60px;
            text-decoration: none;
            height: 100%;
          }
        }

        .nav_item--gray {
          a {
            background: #f3f0ec;
            border: none;
            color: #161616;
            padding-left: 16px;
            padding-right: 16px;
          }
        }

        .nav_item--blue {
          a {
            background: #4d90fe;
            border: none;
            color: #fff;
            padding-left: 16px;
            padding-right: 16px;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
<style>
.el-menu--popup-bottom-start {
  margin-top: 0;
}

.el-dialog__headerbtn .el-dialog__close {
  left: 951px;
  top: 271px;
  width: 25px;
  line-height: 22px;
  color: #4f4f4f;
  border: 1px solid rgba(79, 79, 79, 1);
  border-radius: 50%;
  text-align: center;
}

.el-dialog__close {
  font-size: 16px;
}

.el-dialog__headerbtn:hover .el-dialog__close {
  color: #4f4f4f;
}

.el-button {
  left: 519px;
  top: 534px;
  width: 414px;
  height: 50px;
  line-height: 20px;
  border-radius: 5px;
  background-color: rgba(64, 149, 229, 1);
  text-align: center;
}

.el-button span {
  font-size: 16px;
}

.el-dialog {
  width: 550px !important;
  height: 265px !important;
  margin-top: 300px !important;
}

.el-dialog__body {
  margin-top: 25px;
  text-align: center;
}

.el-dialog__body span {
  left: 573px;
  top: 458px;
  width: 306px;
  height: 36px;
  color: rgba(79, 79, 79, 1);
  font-size: 20px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
}

.el-dialog__footer {
  padding: 25px 68px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/vue/components/Header/index.vue